import { render, staticRenderFns } from "./FodderTable.vue?vue&type=template&id=4531d15a&scoped=true&lang=pug&"
import script from "./FodderTable.vue?vue&type=script&lang=js&"
export * from "./FodderTable.vue?vue&type=script&lang=js&"
import style0 from "./FodderTable.vue?vue&type=style&index=0&id=4531d15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531d15a",
  null
  
)

export default component.exports